/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSession.defs'
export { main as default } from './getSession.defs'
